import {AppLogo, AsyncImage} from "@components";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Stack,
  SxProps,
  TextField,
  Theme,
  Typography,
} from "@mui/material";
import {useThemeContext} from "@theme";
import {translate} from "@util";

const DesktopLogin = ({
  tenantImg,
  rememberMe,
  loading,
  tenantName,
  setRememberMe,
  onSubmit,
}: {
  tenantImg: string | undefined;
  tenantName: string | undefined;
  rememberMe: boolean;
  loading: boolean;
  setRememberMe: (v: boolean) => void;
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
}) => {
  const {theme} = useThemeContext();

  const bgColor = theme.palette.background.default;
  const WebkitTextFillColor = `${theme.palette.text.primary} !important`;
  const WebkitBoxShadow = `0 0 0 100px ${bgColor} inset`;
  const textfieldSx: SxProps<Theme> = {
    "& input:-webkit-autofill": {
      WebkitBoxShadow,
      WebkitTextFillColor,
    },
    "& input:-webkit-autofill:hover": {
      WebkitBoxShadow,
      WebkitTextFillColor,
    },
    "& input:-webkit-autofill:focus": {
      WebkitBoxShadow,
      WebkitTextFillColor,
    },
    "& input:-webkit-autofill:active": {
      WebkitBoxShadow,
      WebkitTextFillColor,
    },
  };

  return (
    <Stack bgcolor={"#DDE3EF"} flex={"1 1 0"} direction="row">
      <Stack
        alignItems={"center"}
        justifyContent={"center"}
        flex={1}
        sx={{
          background: `url(${process.env.PUBLIC_URL}/login-wallpaper.png)`,
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: {lg: "contain", md: "cover"},
        }}></Stack>

      <Stack
        width={480}
        bgcolor={bgColor}
        justifyContent={"space-around"}
        overflow={"auto"}>
        <Box />
        <Stack>
          <Stack alignItems="center">
            <AppLogo logoSize={100} hideText containerSx={{mb: 1}} />
            <Typography variant="h5" color="primary" gutterBottom>
              {translate("pages.login.text")}
            </Typography>
          </Stack>
          <Box
            px={6}
            py={{
              lg: 6,
            }}
            component="form"
            onSubmit={onSubmit}
            noValidate
            sx={{mt: 1}}>
            <TextField
              sx={textfieldSx}
              margin="normal"
              variant="standard"
              required
              fullWidth
              id="username"
              label={translate("pages.login.username")}
              name="username"
              autoComplete="username"
              autoFocus
            />
            <TextField
              sx={textfieldSx}
              variant="standard"
              margin="normal"
              required
              fullWidth
              name="password"
              label={translate("pages.login.password")}
              type="password"
              id="password"
              autoComplete="current-password"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={rememberMe}
                  onChange={(evt, checked) => setRememberMe(checked)}
                />
              }
              label={
                <Typography variant="body1" color="textPrimary">
                  {translate("pages.login.rememberMe")}
                </Typography>
              }
            />
            <Button
              loading={loading}
              type="submit"
              fullWidth
              variant="contained"
              sx={{mt: 3, mb: 2}}>
              {translate("pages.login.login")}
            </Button>
          </Box>
        </Stack>

        <AsyncImage
          id={tenantImg}
          height={120}
          sx={{mb: 4}}
          size="contain"
          fallbackNode={
            <Typography
              variant={"h5"}
              align="center"
              color={theme.palette.common.white}>
              {tenantName}
            </Typography>
          }
        />
      </Stack>
    </Stack>
  );
};

export {DesktopLogin};
